export const GET_PLAYER_REFERRALS_LIST = 'GET_PLAYER_REFERRALS_LIST';
export const GET_PLAYER_REFERRALS_LIST_SUCCESS =
    'GET_PLAYER_REFERRALS_LIST_SUCCESS';
export const GET_PLAYER_REFERRALS_LIST_FAIL =
    'GET_PLAYER_REFERRALS_LIST_FAIL';
